// "RRF, CRAG, and Why 1536 Dimensions" — three letters behind good RAG.
// Cold Compute / Neon kit. ~120s @ 30fps. Grounded in EAKC-MVP.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  three letters behind good RAG
  rrf: { start: 150, duration: 540 }, //       0:05–0:23  reciprocal rank fusion
  rrfCode: { start: 690, duration: 540 }, //   0:23–0:41  the 1/(k+rank) loop
  crag: { start: 1230, duration: 540 }, //     0:41–0:59  corrective RAG grader
  cragFlow: { start: 1770, duration: 480 }, // 0:59–1:15  correct / ambiguous / incorrect
  dims: { start: 2250, duration: 540 }, //     1:15–1:33  why 1536
  payoff: { start: 2790, duration: 420 }, //   1:33–1:47  the stack, fused
  outro: { start: 3210, duration: 330 }, //    1:47–1:58
} as const;

export const TOTAL_DURATION = 3540; // 118s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
